<template>
  <div class="m-auto m-1230">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img src="@/assets/images/EEdT_Thumbnail.png" class="rounded-3" alt="login" />
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto">
          <div class="d-inline-block mb-4">
            <img
              src="/favicon-32x32.png"
              class="rounded-3 for-light-logo"
              alt="login"
            />
            <img
              src="@/assets/images/white-logo.svg"
              class="rounded-3 for-dark-logo"
              alt="login"
            />
          </div>
          <h3 class="fs-28 mb-2">Cambiar contraseña</h3>
          <p class="fw-medium fs-16 mb-4">
            Ingresa una nueva contraseña
          </p>
          <form @submit.prevent="validateForm">
            <div class="form-group mb-3">
              <label class="label text-secondary">Contraseña nueva</label>
              <input
                type="password"
                class="form-control"
                placeholder="Ingresa tu nueva contraseña"
                id="newPassword"
                v-model="userPasswordReset.newPassword" 
                @input="clearError('newPassword');checkStrength()"
              />
              <div class="input-error">{{ errors.newPassword }}</div>
              <div class="strength-bar">
                <div class="strength" :class="strengthClass" :style="{ width: strengthPercent + '%' }"></div>
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="label text-secondary">Confirmar contraseña</label>
              <input
                type="password"
                class="form-control"
                placeholder="Confirma tu contraseña"
                id="confirmPassword"
                v-model="userPasswordReset.confirmPassword" 
                @input="clearError('confirmPassword'); "
              />
              <div class="input-error">{{ errors.confirmPassword }}</div>
              
            </div>
            <div class="form-group mb-3">
              <button type="submit" :disabled="isLoading"  class="btn btn-primary fw-medium py-2 px-3 w-100" >
                <div class="d-flex align-items-center justify-content-center py-1" >
                  <i v-if="!isLoading" class="material-symbols-outlined text-white fs-20 me-2">
                    autorenew
                  </i>
                  <span v-if="!isLoading">Enviar</span> 
                  <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" v-if="isLoading"></span>
                  <span role="status" v-if="isLoading">Procesando...</span>
                </div>
              </button>
            </div>
            <div class="form-group">
              <p>
                Regresar 
                <RouterLink
                  to="/login"
                  class="fw-medium text-primary text-decoration-none"
                >
                  al Login
                </RouterLink>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent , ref, onMounted} from "vue";
import { userResetPasswordSchema } from "@/schemas/userResetPasswordSchema";
import { useRouter } from 'vue-router' 
import { useToast } from "vue-toastification";
import api from '@/services/api';

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "ResetPassword",
  setup() {
    const toast = useToast();
    const router = useRouter()
    const isLoading = ref(false); 
  
    const userPasswordReset = ref<{
      newPassword: any;
      confirmPassword: any;
      username: any
    }>({
      newPassword: null,
      confirmPassword: null,
      username: null
    });
    const errors = ref<Record<string, string>>({});
    const strengthPercent = ref(0);
    const strengthClass = ref('');

    onMounted(async () => { 
      const storedUser = localStorage.getItem("user");
      if (storedUser) {  
        userPasswordReset.value.username = JSON.parse(storedUser).email;
      }
      
    });

    const validateForm = async () => {
    
      try {
        errors.value = {};
        await userResetPasswordSchema.validate(userPasswordReset.value, { abortEarly: false });
        isLoading.value = true;
        
        await changePassword();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " +err)
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = '';
    };
    
    function checkStrength() {
      
      const val = userPasswordReset.value.newPassword  ;
      let strength = 0;

      if(val !=  null){
        if (val.length >= 8) strength += 1;
        if (/[A-Z]/.test(val)) strength += 1;
        if (/[a-z]/.test(val)) strength += 1;
        if (/[0-9]/.test(val)) strength += 1;
        if (/[\W_]/.test(val)) strength += 1;
      }

      strengthPercent.value = (strength / 5) * 100;

      if (strength <= 2) strengthClass.value = 'strength-bar weak';
      else if (strength === 3 || strength === 4) strengthClass.value = 'strength-bar medium';
      else strengthClass.value = 'strength-bar strong';
    }

    const changePassword = async() => {
        try {
          
          await api.post(`/user/change-password`, userPasswordReset.value);
      
          localStorage.setItem("forcePasswordChange", "false"); 

          router.push('/users').catch(err => {
            console.error("Navigation error:", err);
          });
        }catch(ex: any){
          toast.error(ex.response?.data, {
            timeout: 2000
          });
          console.error(ex);
        }
    };

    return { 
      validateForm,
      clearError,
      checkStrength,
      userPasswordReset,
      errors,
      isLoading,
      strengthPercent,
      strengthClass
    };
  }
});
</script>
